const uploadBaseUrl = 'https://yinuojiajiao.fss-my.vhostgo.com/upload'

export function buildUploadAssetUrl(path) {
  if (!path) {
    return ''
  }

  if (/^(https?:)?\/\//.test(path) || /^(data|blob):/.test(path)) {
    return path
  }

  const normalizedPath = String(path)
    .replace(/\\/g, '/')
    .replace(/^(\.\/|\.\.\/)+/, '')
    .replace(/^src\//, '')
    .replace(/^static\//, '')
    .replace(/^\/+/, '')

  return `${uploadBaseUrl}/${normalizedPath}`
}
